import axios from 'axios';

import lstModules from 'common/json/lstModules.json';
import { Form } from 'react-router-dom';

const httpURL = lstModules['main'].url + ':' + lstModules['main'].port;
const httpURL1 = lstModules['local'].url + ':' + lstModules['local'].port;
var tokenid = localStorage.getItem("tokenid");
const acdYrId = parseInt(localStorage.getItem('academicYearId')) || 0;
const wingId = parseInt(localStorage.getItem('wingId')) || 0;

export const uploadManualTtExcelSvc = (formData, cb) => {
    var status = 'Success'
    var obj = { status: status };
    axios({
        url: httpURL1 + '/sms/tt/v2/tt_schedule_5/excel/upload/manual',
        method: "POST",
        data: formData,
        headers: { tokenid },
        withCredentials: true,
    }).then((response) => {
        if (response.data.SvcStatus === "Success") {

            obj.message = response.data.SvcMsg;
            obj.status = response.data.SvcStatus;
        } else {
            obj.message = response.data.SvcMsg;
            obj.status = response.data.SvcStatus;
        }
        cb(obj)
    }).catch((e) => {
        obj.status = 'Exception';
        obj.message = e;
        cb(obj)

    });
}
export const getSessionListSvc = (callback) => {
    // console.log("getSessionListSvc called");
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/acdSch/list',
        method: "POST",
        params: { acdYrId, wingId },
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {
        // console.log('response from getSessionListSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === "Success") {
            obj.lstAcademicSchedule = response.data.lstAcademicSchedule;
        }
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;

        callback(obj);
    });
}
export const getScheduleSvc = (sessionId, objType, callback) => {
    // console.log("getScheduleSvc called, sessionId", sessionId, ", objType", objType);
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/tt/v2/tt_schedule_report/days',
        method: "POST",
        params: { sessionId, objType },
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {
        // console.log('response from getScheduleSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === "Success") {
            obj.lstPeriodHdr = response.data.lstPeriodHdr;
            obj.lstDay = response.data.lstDay;
        }
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;

        callback(obj);
    });
}

export const getScheduleSvc2 = (sessionId, objType, callback) => {
    // console.log("getScheduleSvc called, sessionId", sessionId, ", objType", objType);
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/tt/v3/tt_schedule_report/days',
        method: "POST",
        params: { sessionId, objType },
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {
        // console.log('response from getScheduleSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === "Success") {
            obj.lstPeriodHdr = response.data.lstPeriodHdr;
            obj.lstDay = response.data.lstDay;
        }
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;

        callback(obj);
    });
}

export const generateScheduleSvc = (sessionId, callback) => {
    // console.log("generateScheduleSvc called");
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/tt/v2/tt_schedule/generate',
        method: "POST",
        params: { sessionId, wingId },
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {
        // console.log('response from generateScheduleSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;

        callback(obj);
    });
}

export const getScheduleExcelSvc = (sessionId, objType, callback) => {
    axios({
        url: httpURL + '/sms/tt/v3/tt_schedule_report/days_excel',
        method: "POST",
        params: { sessionId, objType },       
        headers: { 'tokenid': tokenid },
        withCredentials: true,
        responseType: 'arraybuffer',           
    }).then((response) => {
        callback(response);
    }).catch((error) => {
        callback({ error });
    });
}

export const generateScheduleBSvc = (commonClsOnly, sessionId, callback) => {
    // console.log("generateScheduleBSvc called");
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/tt/v2/tt_schedule_3/generate',
        method: "POST",
        params: { sessionId, wingId, commonClsOnly },
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {
        // console.log('response from generateScheduleBSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;

        callback(obj);
    });
}

export const generateScheduleCSvc = (sessionId, callback) => {
    // console.log("generateScheduleCSvc called");
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/tt/v2/tt_schedule_4/generate',
        method: "POST",
        params: { sessionId, wingId },
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {
        // console.log('response from generateScheduleCSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;

        callback(obj);
    });
}

export function excelReportSvc(callBack) {
    const formData = new FormData();
    formData.append("sessionId", 1);
    axios(
        {
            url: httpURL + "/sms/tt/v2/tt_report/tch_load_report",
            method: "POST",
            data: formData,
            headers: { 'tokenid': tokenid },
            withCredentials: true,
            responseType: 'arraybuffer',
        }
    ).then((response) => {
        callBack(response);

    }
    ).catch((error) => {
        console.error(error)
    });
}


//new schedule generation
export const generateAutoScheduleSvc = (sessionId, callback) => {
    console.log("generateAutoScheduleSvc called");
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/tt/v2/auto_schedule/generate',
        method: "POST",
        params: { sessionId, screenId:1, commonClsOnly: false },
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {
        // console.log('response from generateScheduleCSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;

        callback(obj);
    });
}

